import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';

import { Group, GroupFilters } from '../../../../app/models/Group';
import GroupFilter from './GroupFilter';
import GroupSwitchChange from '../GroupSwitchChange';

interface Props {
    groups: Group[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    notifications?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: GroupFilters;
    setFilter: (filter: GroupFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const GroupDataTable = ({
    groups,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    notifications,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: Group, index: any, column: any) => <span className="">{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: Group, index: any, column: any) => <span className="">{row.name}</span>
        },

        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: Group, index: any, column: any) => (
                <GroupSwitchChange
                    checkValue={row.is_active ?? true}
                    groupId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: Group, index: any, column: any) => (
                <div className="d-flex align-items-center">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            title="Ver"
                            classIcon="fa-eye"
                            colorIcon="text-info"
                            sizeIcon="16"
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            title="Editar"
                            classIcon="fa-edit"
                            colorIcon="text-warning"
                            sizeIcon="16"
                        />
                    )}

                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            title="Eliminar"
                            classIcon="fa-trash"
                            colorIcon="text-danger"
                            sizeIcon="16"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <GroupFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={groups}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default GroupDataTable;